import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactHighcharts from "react-highcharts";
import HighchartsMore from "highcharts-more";
import Pareto from "highcharts/modules/pareto";
import SolidGauge from "highcharts/modules/solid-gauge";
import classNames from 'classnames';
import {commercialHoursInInterval, convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import Grid from "@material-ui/core/Grid/Grid";
import ComplexGrid from "../../../common/ComplexGrid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {};
var perioddata = [];
var cH = null;

const useStyles = makeStyles(theme => ({

  mainGrid: {
   // backgroundColor: 'cyan',
      margin: '6px 0px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch'
  },
  marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      margin: '8px',
      border: '3px',
      borderColor: 'yellow',
    // display: 'flex',
    //   flexGrow: '0.2',
      // width: '100%',
    //   height: '100%'
  }
}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function PneusKPIs(prop) {
  const {fabricantes, modelos, bandas, medidas, modelosfinalizados, filter, isLoading} = prop;
  const classes = useStyles();


  if (isLoading) {return renderLoadingScreen()}

  let tpneus = 0;
  modelos.map(m => {
    //  console.log("contando pneus...", tpneus)
      tpneus = tpneus + m.total
  });


    let tpneusFinalizados = 0;
    modelosfinalizados.map(m => {
        //  console.log("contando pneus...", tpneus)
        tpneusFinalizados = tpneusFinalizados + m.total
    })

  return (
    <Grid container item xs={12} lg={12} className={classes.mainGrid}>
      <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            leftSideGrid={true}
          iconState="success"
          icon="business_money-coins"
          mainvalue={<span>{tpneus}</span>}
          title={<span>PNEUS RECEBIDOS</span>}
            description={<span># pneus cadastrados</span>}
            unit="un"
        />
      </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            mainvalue={<span>{fabricantes.length}</span>}
          title={<span>FABRICANTES</span>}
          description={<span># fabricantes distintos.</span>}
            unit="un"
        />
        </Grid>


        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
          mainvalue={modelos.length}
          title={<span>MODELOS</span>}
          description={<span>#modelos distintos</span>}
          unit="un"
        />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
            <ComplexGrid
                className={classes.marginAuto}
                rightSideGrid={true}
                mainvalue={<span>{medidas.length}</span>}
                title={<span>MEDIDAS</span>}
                description={<span># medidas distintas das carcaças</span>}
                unit={<span>un</span>}

            />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            rightSideGrid={true}
            mainvalue={<span>{bandas.length}</span>}
            title={<span>BANDAS</span>}
            description="# modelos bandas distintas"
            unit={<span>un</span>}

        />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
            <ComplexGrid
                className={classes.marginAuto}
                leftSideGrid={true}
                iconState="success"
                icon="business_money-coins"
                mainvalue={<span>{tpneusFinalizados}</span>}
                title={<span>PNEUS FINALIZADOS</span>}
                description={<span># pneus finalizados</span>}
                unit="un"
            />
        </Grid>

    </Grid>
  )
}
;
